import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-66e9145c"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "mt-4",
  style: {"font-size":"0.75rem"}
}, [
  /*#__PURE__*/_createTextVNode(" Регистрируясь, вы: "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" Принимаете "),
  /*#__PURE__*/_createElementVNode("a", { href: "https://zapravit-avto.ru/corp-offerta" }, "Оферту"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" Подтверждаете, что ознакомились с "),
  /*#__PURE__*/_createElementVNode("a", { href: "https://zapravit-avto.ru/personal-data-policy" }, "Политикой обработки персональных данных"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" Соглашаетесь "),
  /*#__PURE__*/_createElementVNode("a", { href: "https://zapravit-avto.ru/personal-data-processing-consent" }, "на сбор и обработку персональных данных")
], -1))
const _hoisted_2 = { class: "mt-8 text--center" }

import { ref, onMounted } from 'vue';
import Masks from '@/helpers/masks';
import SberId from '@/views/auth/components/SberId.vue';
import ShowDocumentModal from '@/components/Modals/ShowDocumentModal.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'RegisterByPhone',
  props: {
  isPhoneDisabled: {
    type: Boolean,
    default: false,
  },
  hasSignInError: {
    type: Boolean,
    default: false,
  },
},
  emits: ['update:phone', 'goToLogin', 'submit'],
  setup(__props, { emit }) {

const props = __props;





const phone = ref('');
const phoneRef = ref();
const isDocVisible = ref(false);
const docUrl = ref('');

onMounted(() => {
  setTimeout(() => phoneRef.value.focus(), 200);
});

const updatePhone = () => emit('update:phone', phone.value);
const goToLogin = () => emit('goToLogin');
const submit = () => {
  if (props.isPhoneDisabled) {
    return;
  }
  emit('submit', phone.value);
};

return (_ctx: any,_cache: any) => {
  const _component_UiInput = _resolveComponent("UiInput")!
  const _component_UiButton = _resolveComponent("UiButton")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_UiInput, {
      ref_key: "phoneRef",
      ref: phoneRef,
      modelValue: phone.value,
      "onUpdate:modelValue": [
        _cache[0] || (_cache[0] = ($event: any) => ((phone).value = $event)),
        updatePhone
      ],
      placeholder: "Телефон",
      size: "large",
      mask: { mask: _unref(Masks).phone },
      error: __props.hasSignInError,
      onPressEnter: submit
    }, null, 8, ["modelValue", "mask", "error"]),
    _createVNode(_component_UiButton, {
      class: "mt-4 button-submit",
      type: "primary",
      size: "large",
      disabled: __props.isPhoneDisabled,
      onClick: submit
    }, {
      default: _withCtx(() => [
        _createTextVNode(" Зарегистрироваться ")
      ]),
      _: 1
    }, 8, ["disabled"]),
    _hoisted_1,
    _createVNode(SberId, { class: "mt-8" }),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_UiButton, {
        type: "link",
        size: "large",
        onClick: goToLogin
      }, {
        default: _withCtx(() => [
          _createTextVNode("Я уже клиент сервиса")
        ]),
        _: 1
      })
    ]),
    (isDocVisible.value)
      ? (_openBlock(), _createBlock(ShowDocumentModal, {
          key: 0,
          docUrl: docUrl.value,
          onClose: _cache[1] || (_cache[1] = ($event: any) => (isDocVisible.value = false))
        }, null, 8, ["docUrl"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})